// extracted by mini-css-extract-plugin
module.exports = {"root":"FormattedText_root__6kjpu","c2aVariant":"FormattedText_c2aVariant__UHw_O"};